module.exports = __webpack_public_path__ + "img/Skirt-Front-B8-Da-Fc-Hc-Ia.06bd1231.png";